import { render, staticRenderFns } from "./InvoiceUpcomingModal.vue?vue&type=template&id=6960ec74&"
import script from "./InvoiceUpcomingModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceUpcomingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports